import { useState } from 'react';
/**
 * Hook that manages UI state for survey, error component, and map visibility
 * @returns and object containing UI state
 * @public
 */
export const useChatUIState = () => {
  const [showSurvey, setShowSurvey] = useState(false);
  const [openErrorComponent, setOpenErrorComponent] = useState(false);
  const [isMapOpened, setIsMapOpened] = useState(false);
  return {
    showSurvey,
    setShowSurvey,
    openErrorComponent,
    setOpenErrorComponent,
    isMapOpened,
    setIsMapOpened
  };
};